import { FC } from "react";
import { useRecoilValue } from "recoil";

import { isLoggedInAtom } from "@ryde/shared";

import { RydeEvents } from "./ryde-events";

export const RydeEventsWrapper: FC = () => {
  const isLoggedIn = useRecoilValue(isLoggedInAtom);
  return isLoggedIn && <RydeEvents />;
};
